import { render, staticRenderFns } from "./OrderReceipt.vue?vue&type=template&id=12b6e5ca&scoped=true"
import script from "./OrderReceipt.vue?vue&type=script&lang=js"
export * from "./OrderReceipt.vue?vue&type=script&lang=js"
import style0 from "./OrderReceipt.vue?vue&type=style&index=0&id=12b6e5ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b6e5ca",
  null
  
)

export default component.exports